"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2824],{

/***/ 38144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx
// @ts-nocheck

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm.keyframes)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65ff4d33-0"
}).withConfig({
    componentId: "sc-117abfeb-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm.css)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm["default"])(Box/* default */.Z).withConfig({
    componentId: "sc-65ff4d33-1"
}).withConfig({
    componentId: "sc-117abfeb-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx
// @ts-nocheck






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 44455:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var DELIST_COLLECTIONS = {
    "0x4D89eBf7b1F66806A4C99Df71D22b7b9efC6bB0b": {
        active: false,
        address: "0x4D89eBf7b1F66806A4C99Df71D22b7b9efC6bB0b",
        avatar: "",
        banner: {
            large: "",
            small: ""
        },
        createdAt: "",
        creatorAddress: "",
        creatorFee: "",
        description: "",
        id: "0x4d89ebf7b1f66806a4c99df71d22b7b9efc6bb0b",
        name: "Baked Potatoes",
        numberTokensListed: "76",
        owner: "0xCd1B0abBc3E55E91FCC5AEE393525e68478C2952",
        symbol: "POT",
        totalSupply: "",
        totalTrades: "",
        totalVolumeBNB: "",
        tradingFee: "",
        updatedAt: "",
        verified: true,
        whitelistChecker: ""
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (DELIST_COLLECTIONS);


/***/ }),

/***/ 86849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HD": function() { return /* binding */ combineApiAndSgResponseToNftToken; },
  "nh": function() { return /* binding */ fetchNftsFiltered; },
  "LU": function() { return /* binding */ getAllPancakeBunniesLowestPrice; },
  "nP": function() { return /* binding */ getAllPancakeBunniesRecentUpdatedAt; },
  "_N": function() { return /* binding */ getCollection; },
  "Du": function() { return /* binding */ getCollectionActivity; },
  "iE": function() { return /* binding */ getCollectionDistributionApi; },
  "bG": function() { return /* binding */ getCollections; },
  "A8": function() { return /* binding */ getCompleteAccountNftData; },
  "dk": function() { return /* binding */ getLatestListedNfts; },
  "Um": function() { return /* binding */ getLeastMostPriceInCollection; },
  "Z1": function() { return /* binding */ getMarketDataForTokenIds; },
  "M2": function() { return /* binding */ getMetadataWithFallback; },
  "hb": function() { return /* binding */ getNftApi; },
  "Rq": function() { return /* binding */ getNftsFromCollectionApi; },
  "_C": function() { return /* binding */ getNftsFromDifferentCollectionsApi; },
  "T5": function() { return /* binding */ getNftsMarketData; },
  "DS": function() { return /* binding */ getNftsOnChainMarketData; },
  "tU": function() { return /* binding */ getNftsUpdatedMarketData; },
  "rD": function() { return /* binding */ getPancakeBunniesAttributesField; },
  "AC": function() { return /* binding */ getTokenActivity; },
  "_z": function() { return /* binding */ getUserActivity; }
});

// UNUSED EXPORTS: attachMarketDataToWalletNfts, combineCollectionData, combineNftMarketAndMetadata, fetchWalletTokenIdsForCollections, getAccountNftsOnChainMarketData, getCollectionApi, getCollectionSg, getCollectionsApi, getCollectionsSg, getNftLocationForMarketNft, getNftsByBunnyIdSg, getNftsFromCollectionSg

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(46587);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./src/config/abi/erc721.json
var erc721 = __webpack_require__(53400);
// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 25 modules
var contractHelpers = __webpack_require__(97844);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/config/constants/nftsCollections/delist.ts
var delist = __webpack_require__(44455);
// EXTERNAL MODULE: ./src/views/Nft/market/constants.ts
var market_constants = __webpack_require__(40580);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
// EXTERNAL MODULE: ./src/config/abi/nftMarket.json
var nftMarket = __webpack_require__(60290);
// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__(17204);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);
// EXTERNAL MODULE: ./src/state/nftMarket/types.ts
var types = __webpack_require__(75186);
;// CONCATENATED MODULE: ./src/state/nftMarket/queries.ts
var baseNftFields = "\n  tokenId\n  metadataUrl\n  currentAskPrice\n  currentSeller\n  latestTradedPriceInBNB\n  tradeVolumeBNB\n  totalTrades\n  isTradable\n  updatedAt\n  otherId\n  collection {\n    id\n  }\n";
var baseTransactionFields = "\n  id\n  block\n  timestamp\n  askPrice\n  netPrice\n  withBNB\n  buyer {\n    id\n  }\n  seller {\n    id\n  }\n";
var collectionBaseFields = "\n  id\n  name\n  symbol\n  active\n  totalTrades\n  totalVolumeBNB\n  numberTokensListed\n  creatorAddress\n  tradingFee\n  creatorFee\n  whitelistChecker\n";

;// CONCATENATED MODULE: ./src/state/nftMarket/helpers.ts







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getCollectionData($collectionAddress: String!) {\n          collection(id: $collectionAddress) {\n            ",
        "\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        {\n          collections {\n            ",
        "\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getNftCollectionMarketData($collectionAddress: String!) {\n          collection(id: $collectionAddress) {\n            id\n            nfts(orderBy:",
        ", skip: $skip, first: $first) {\n             ",
        "\n            }\n          }\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getNftsByBunnyIdSg($collectionAddress: String!, $where: NFT_filter, $orderDirection: String!) {\n          nfts(first: 30, where: $where, orderBy: currentAskPrice, orderDirection: $orderDirection) {\n            ",
        "\n          }\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getMarketDataForTokenIds($collectionAddress: String!, $where: NFT_filter) {\n          collection(id: $collectionAddress) {\n            id\n            nfts(first: 1000, where: $where) {\n              ",
        "\n            }\n          }\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getNftsMarketData($first: Int, $skip: Int!, $where: NFT_filter, $orderBy: NFT_orderBy, $orderDirection: OrderDirection) {\n          nfts(where: $where, first: $first, orderBy: $orderBy, orderDirection: $orderDirection, skip: $skip) {\n            ",
        "\n            transactionHistory {\n              ",
        "\n            }\n          }\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getAllPancakeBunniesLowestPrice {\n          ",
        "\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getAllPancakeBunniesLowestPrice {\n          ",
        "\n        }\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getUserActivity($address: String!) {\n          user(id: $address) {\n            buyTradeHistory(first: 250, orderBy: timestamp, orderDirection: desc) {\n              ",
        "\n              nft {\n                ",
        "\n              }\n            }\n            sellTradeHistory(first: 250, orderBy: timestamp, orderDirection: desc) {\n              ",
        "\n              nft {\n                ",
        "\n              }\n            }\n            askOrderHistory(first: 500, orderBy: timestamp, orderDirection: desc) {\n              id\n              block\n              timestamp\n              orderType\n              askPrice\n              nft {\n                ",
        "\n              }\n            }\n          }\n        }\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getCollectionActivity {\n          ",
        "\n          ",
        "\n        }\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getCollectionActivity($tokenId: BigInt!, $address: ID!) {\n          nfts(where:{tokenId: $tokenId, collection: $address}) {\n            transactionHistory(orderBy: timestamp, orderDirection: desc) {\n              ",
        "\n                nft {\n                  ",
        "\n                }\n            }\n            askHistory(orderBy: timestamp, orderDirection: desc) {\n                id\n                block\n                timestamp\n                orderType\n                askPrice\n                seller {\n                  id\n                }\n                nft {\n                  ",
        "\n                }\n            }\n          }\n        }\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getLatestNftMarketData($first: Int) {\n          nfts(where: { isTradable: true }, orderBy: updatedAt , orderDirection: desc, first: $first) {\n            ",
        "\n            collection {\n              id\n            }\n          }\n        }\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

















/**
 * API HELPERS
 */ /**
 * Fetch static data from all collections using the API
 * @returns
 */ var getCollectionsApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(endpoints/* API_NFT */.C1, "/collections"))
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    json = _state.sent();
                    return [
                        2,
                        json
                    ];
                case 3:
                    console.error("Failed to fetch NFT collections", res.statusText);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getCollectionsApi() {
        return _ref.apply(this, arguments);
    };
}();
var fetchCollectionsTotalSupply = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collections) {
        var totalSupplyCalls, totalSupplyRaw, totalSupply;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    totalSupplyCalls = collections.filter(function(collection) {
                        return collection === null || collection === void 0 ? void 0 : collection.address;
                    }).map(function(collection) {
                        return {
                            address: collection.address.toLowerCase(),
                            name: "totalSupply"
                        };
                    });
                    if (!(totalSupplyCalls.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: erc721,
                            calls: totalSupplyCalls,
                            options: {
                                requireSuccess: false
                            }
                        })
                    ];
                case 1:
                    totalSupplyRaw = _state.sent();
                    totalSupply = totalSupplyRaw.flat();
                    return [
                        2,
                        totalSupply.map(function(totalCount) {
                            return totalCount ? totalCount.toNumber() : 0;
                        })
                    ];
                case 2:
                    return [
                        2,
                        []
                    ];
            }
        });
    });
    return function fetchCollectionsTotalSupply(collections) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch all collections data by combining data from the API (static metadata) and the Subgraph (dynamic market data)
 */ var getCollections = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, collections, collectionsMarket, ref1, collectionApiData, collectionsTotalSupply, collectionApiDataCombinedOnChain, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.all([
                            getCollectionsApi(),
                            getCollectionsSg()
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), collections = ref[0], collectionsMarket = ref[1];
                    collectionApiData = (ref1 = collections === null || collections === void 0 ? void 0 : collections.data) !== null && ref1 !== void 0 ? ref1 : [];
                    return [
                        4,
                        fetchCollectionsTotalSupply(collectionApiData)
                    ];
                case 2:
                    collectionsTotalSupply = _state.sent();
                    collectionApiDataCombinedOnChain = collectionApiData.map(function(collection, index) {
                        var totalSupplyFromApi = Number(collection === null || collection === void 0 ? void 0 : collection.totalSupply) || 0;
                        var totalSupplyFromOnChain = collectionsTotalSupply[index];
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                            totalSupply: Math.max(totalSupplyFromApi, totalSupplyFromOnChain).toString()
                        });
                    });
                    return [
                        2,
                        combineCollectionData(collectionApiDataCombinedOnChain, collectionsMarket)
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Unable to fetch data:", error);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCollections() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch collection data by combining data from the API (static metadata) and the Subgraph (dynamic market data)
 */ var getCollection = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var ref, collection, collectionMarket, collectionsTotalSupply, totalSupplyFromApi, totalSupplyFromOnChain, collectionApiDataCombinedOnChain, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.all([
                            getCollectionApi(collectionAddress),
                            getCollectionSg(collectionAddress)
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), collection = ref[0], collectionMarket = ref[1];
                    return [
                        4,
                        fetchCollectionsTotalSupply([
                            collection
                        ])
                    ];
                case 2:
                    collectionsTotalSupply = _state.sent();
                    totalSupplyFromApi = Number(collection === null || collection === void 0 ? void 0 : collection.totalSupply) || 0;
                    totalSupplyFromOnChain = collectionsTotalSupply[0];
                    collectionApiDataCombinedOnChain = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, collection), {
                        totalSupply: Math.max(totalSupplyFromApi, totalSupplyFromOnChain).toString()
                    });
                    return [
                        2,
                        combineCollectionData([
                            collectionApiDataCombinedOnChain
                        ], [
                            collectionMarket
                        ])
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Unable to fetch data:", error);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCollection(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch static data from a collection using the API
 * @returns
 */ var getCollectionApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var res, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(endpoints/* API_NFT */.C1, "/collections/").concat(collectionAddress))
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    json = _state.sent();
                    return [
                        2,
                        json.data
                    ];
                case 3:
                    console.error("API: Failed to fetch NFT collection ".concat(collectionAddress), res.statusText);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getCollectionApi(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch static data for all nfts in a collection using the API
 * @param collectionAddress
 * @param size
 * @param page
 * @returns
 */ var getNftsFromCollectionApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var size, page, isPBCollection, requestPath, res, data, filteredAttributesDistribution, filteredData, filteredTotal, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    size = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 100, page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1;
                    isPBCollection = collectionAddress.toLowerCase() === market_constants/* pancakeBunniesAddress.toLowerCase */.J.toLowerCase();
                    requestPath = "".concat(endpoints/* API_NFT */.C1, "/collections/").concat(collectionAddress, "/tokens").concat(!isPBCollection ? "?page=".concat(page, "&size=").concat(size) : "");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(requestPath)
                    ];
                case 2:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 3:
                    data = _state.sent();
                    filteredAttributesDistribution = Object.entries(data.attributesDistribution).filter(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return Boolean(value);
                    });
                    filteredData = Object.entries(data.data).filter(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return Boolean(value);
                    });
                    filteredTotal = filteredData.length;
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            total: filteredTotal,
                            attributesDistribution: fromPairs_default()(filteredAttributesDistribution),
                            data: fromPairs_default()(filteredData)
                        })
                    ];
                case 4:
                    console.error("API: Failed to fetch NFT tokens for ".concat(collectionAddress, " collection"), res.statusText);
                    return [
                        2,
                        null
                    ];
                case 5:
                    error = _state.sent();
                    console.error("API: Failed to fetch NFT tokens for ".concat(collectionAddress, " collection"), error);
                    return [
                        2,
                        null
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNftsFromCollectionApi(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch a single NFT using the API
 * @param collectionAddress
 * @param tokenId
 * @returns NFT from API
 */ var getNftApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress, tokenId) {
        var res, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(endpoints/* API_NFT */.C1, "/collections/").concat(collectionAddress, "/tokens/").concat(tokenId))
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    json = _state.sent();
                    return [
                        2,
                        json.data
                    ];
                case 3:
                    console.error("API: Can't fetch NFT token ".concat(tokenId, " in ").concat(collectionAddress), res.status);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getNftApi(collectionAddress, tokenId) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch a list of NFT from different collections
 * @param from Array of { collectionAddress: string; tokenId: string }
 * @returns Array of NFT from API
 */ var getNftsFromDifferentCollectionsApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(from) {
        var promises, responses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    promises = from.map(function(nft) {
                        return getNftApi(nft.collectionAddress, nft.tokenId);
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    responses = _state.sent();
                    // Sometimes API can't find some tokens (e.g. 404 response)
                    // at least return the ones that returned successfully
                    return [
                        2,
                        responses.filter(function(resp) {
                            return resp;
                        }).map(function(res, index) {
                            return {
                                tokenId: res.tokenId,
                                name: res.name,
                                collectionName: res.collection.name,
                                collectionAddress: from[index].collectionAddress,
                                description: res.description,
                                attributes: res.attributes,
                                createdAt: res.createdAt,
                                updatedAt: res.updatedAt,
                                image: res.image
                            };
                        })
                    ];
            }
        });
    });
    return function getNftsFromDifferentCollectionsApi(from) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * SUBGRAPH HELPERS
 */ /**
 * Fetch market data from a collection using the Subgraph
 * @returns
 */ var getCollectionSg = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject(), collectionBaseFields), {
                            collectionAddress: collectionAddress.toLowerCase()
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.collection
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch collection", error);
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCollectionSg(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch market data from all collections using the Subgraph
 * @returns
 */ var getCollectionsSg = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject1(), collectionBaseFields))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.collections
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch NFT collections", error);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCollectionsSg() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch market data for nfts in a collection using the Subgraph
 * @param collectionAddress
 * @param first
 * @param skip
 * @returns
 */ var getNftsFromCollectionSg = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var first, skip, isPBCollection, res, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    first = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1000, skip = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0;
                    isPBCollection = collectionAddress.toLowerCase() === market_constants/* pancakeBunniesAddress.toLowerCase */.J.toLowerCase();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject2(), isPBCollection ? "updatedAt" : "tokenId", baseNftFields), {
                            collectionAddress: collectionAddress.toLowerCase(),
                            skip: skip,
                            first: first
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res.collection.nfts
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch NFTs from collection", error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNftsFromCollectionSg(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch market data for PancakeBunnies NFTs by bunny id using the Subgraph
 * @param bunnyId - bunny id to query
 * @param existingTokenIds - tokens that are already loaded into redux
 * @returns
 */ var getNftsByBunnyIdSg = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(bunnyId, existingTokenIds, orderDirection) {
        var where, res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    where = existingTokenIds.length > 0 ? {
                        otherId: bunnyId,
                        isTradable: true,
                        tokenId_not_in: existingTokenIds
                    } : {
                        otherId: bunnyId,
                        isTradable: true
                    };
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject3(), baseNftFields), {
                            collectionAddress: market_constants/* pancakeBunniesAddress.toLowerCase */.J.toLowerCase(),
                            where: where,
                            orderDirection: orderDirection
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.nfts
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch collection NFTs for bunny id ".concat(bunnyId), error);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNftsByBunnyIdSg(bunnyId, existingTokenIds, orderDirection) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch market data for PancakeBunnies NFTs by bunny id using the Subgraph
 * @param bunnyId - bunny id to query
 * @param existingTokenIds - tokens that are already loaded into redux
 * @returns
 */ var getMarketDataForTokenIds = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress, existingTokenIds) {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (existingTokenIds.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject4(), baseNftFields), {
                            collectionAddress: collectionAddress.toLowerCase(),
                            where: {
                                tokenId_in: existingTokenIds
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.collection.nfts
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch market data for NFTs stored tokens", error);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getMarketDataForTokenIds(collectionAddress, existingTokenIds) {
        return _ref.apply(this, arguments);
    };
}();
var getNftsOnChainMarketData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress, tokenIds) {
        var nftMarketContract, response, askInfo, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    nftMarketContract = (0,contractHelpers/* getNftMarketContract */.X$)();
                    return [
                        4,
                        nftMarketContract.viewAsksByCollectionAndTokenIds(collectionAddress.toLowerCase(), tokenIds)
                    ];
                case 1:
                    response = _state.sent();
                    askInfo = response === null || response === void 0 ? void 0 : response.askInfo;
                    if (!askInfo) return [
                        2,
                        []
                    ];
                    return [
                        2,
                        askInfo.map(function(tokenAskInfo, index) {
                            if (!tokenAskInfo.seller || !tokenAskInfo.price) return null;
                            var currentSeller = tokenAskInfo.seller;
                            var isTradable = currentSeller.toLowerCase() !== constants/* NOT_ON_SALE_SELLER */.Vc;
                            var currentAskPrice = tokenAskInfo.price && (0,formatBalance/* formatBigNumber */.dp)(tokenAskInfo.price);
                            return {
                                collection: {
                                    id: collectionAddress.toLowerCase()
                                },
                                tokenId: tokenIds[index],
                                currentSeller: currentSeller,
                                isTradable: isTradable,
                                currentAskPrice: currentAskPrice
                            };
                        }).filter(Boolean)
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch NFTs onchain market data", error);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNftsOnChainMarketData(collectionAddress, tokenIds) {
        return _ref.apply(this, arguments);
    };
}();
var getNftsUpdatedMarketData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress, tokenIds) {
        var nftMarketContract, response, askInfo, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    nftMarketContract = (0,contractHelpers/* getNftMarketContract */.X$)();
                    return [
                        4,
                        nftMarketContract.viewAsksByCollectionAndTokenIds(collectionAddress.toLowerCase(), tokenIds)
                    ];
                case 1:
                    response = _state.sent();
                    askInfo = response === null || response === void 0 ? void 0 : response.askInfo;
                    if (!askInfo) return [
                        2,
                        null
                    ];
                    return [
                        2,
                        askInfo.map(function(tokenAskInfo, index) {
                            var isTradable = tokenAskInfo.seller ? tokenAskInfo.seller.toLowerCase() !== constants/* NOT_ON_SALE_SELLER */.Vc : false;
                            return {
                                tokenId: tokenIds[index],
                                currentSeller: tokenAskInfo.seller,
                                isTradable: isTradable,
                                currentAskPrice: tokenAskInfo.price
                            };
                        })
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch updated NFT market data", error);
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNftsUpdatedMarketData(collectionAddress, tokenIds) {
        return _ref.apply(this, arguments);
    };
}();
var getAccountNftsOnChainMarketData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collections, account) {
        var nftMarketAddress, collectionList, askCalls, askCallsResultsRaw, askCallsResults, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    nftMarketAddress = (0,addressHelpers/* getNftMarketAddress */.D4)();
                    collectionList = Object.values(collections);
                    askCalls = collectionList.map(function(collection) {
                        var collectionAddress = collection.address;
                        return {
                            address: nftMarketAddress,
                            name: "viewAsksByCollectionAndSeller",
                            params: [
                                collectionAddress,
                                account,
                                0,
                                1000
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: nftMarket,
                            calls: askCalls,
                            options: {
                                requireSuccess: false
                            }
                        })
                    ];
                case 1:
                    askCallsResultsRaw = _state.sent();
                    askCallsResults = askCallsResultsRaw.map(function(askCallsResultRaw, askCallIndex) {
                        var ref;
                        if (!(askCallsResultRaw === null || askCallsResultRaw === void 0 ? void 0 : askCallsResultRaw.tokenIds) || !(askCallsResultRaw === null || askCallsResultRaw === void 0 ? void 0 : askCallsResultRaw.askInfo) || !((ref = collectionList[askCallIndex]) === null || ref === void 0 ? void 0 : ref.address)) return null;
                        return askCallsResultRaw.tokenIds.map(function(tokenId, tokenIdIndex) {
                            if (!tokenId || !askCallsResultRaw.askInfo[tokenIdIndex] || !askCallsResultRaw.askInfo[tokenIdIndex].price) return null;
                            var currentAskPrice = (0,formatBalance/* formatBigNumber */.dp)(askCallsResultRaw.askInfo[tokenIdIndex].price);
                            return {
                                collection: {
                                    id: collectionList[askCallIndex].address.toLowerCase()
                                },
                                tokenId: tokenId.toString(),
                                account: account,
                                isTradable: true,
                                currentAskPrice: currentAskPrice
                            };
                        }).filter(Boolean);
                    }).flat().filter(Boolean);
                    return [
                        2,
                        askCallsResults
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch NFTs onchain market data", error);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAccountNftsOnChainMarketData(collections, account) {
        return _ref.apply(this, arguments);
    };
}();
var getNftsMarketData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var where, first, orderBy, orderDirection, skip, res, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    where = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, first = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1000, orderBy = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "id", orderDirection = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "desc", skip = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 0;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject5(), baseNftFields, baseTransactionFields), {
                            where: where,
                            first: first,
                            skip: skip,
                            orderBy: orderBy,
                            orderDirection: orderDirection
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res.nfts
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch NFTs market data", error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNftsMarketData() {
        return _ref.apply(this, arguments);
    };
}();
var getAllPancakeBunniesLowestPrice = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(bunnyIds) {
        var singlePancakeBunnySubQueries, rawResponse, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    singlePancakeBunnySubQueries = bunnyIds.map(function(bunnyId) {
                        return "b".concat(bunnyId, ":nfts(first: 1, where: { otherId: ").concat(bunnyId, ", isTradable: true }, orderBy: currentAskPrice, orderDirection: asc) {\n        currentAskPrice\n      }\n    ");
                    });
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject6(), singlePancakeBunnySubQueries))
                    ];
                case 1:
                    rawResponse = _state.sent();
                    return [
                        2,
                        fromPairs_default()(Object.keys(rawResponse).map(function(subQueryKey) {
                            var bunnyId = subQueryKey.split("b")[1];
                            return [
                                bunnyId,
                                rawResponse[subQueryKey].length > 0 ? parseFloat(rawResponse[subQueryKey][0].currentAskPrice) : Infinity, 
                            ];
                        }))
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch PancakeBunnies lowest prices", error);
                    return [
                        2,
                        {}
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAllPancakeBunniesLowestPrice(bunnyIds) {
        return _ref.apply(this, arguments);
    };
}();
var getAllPancakeBunniesRecentUpdatedAt = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(bunnyIds) {
        var singlePancakeBunnySubQueries, rawResponse, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    singlePancakeBunnySubQueries = bunnyIds.map(function(bunnyId) {
                        return "b".concat(bunnyId, ":nfts(first: 1, where: { otherId: ").concat(bunnyId, ", isTradable: true }, orderBy: updatedAt, orderDirection: desc) {\n        updatedAt\n      }\n    ");
                    });
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject7(), singlePancakeBunnySubQueries))
                    ];
                case 1:
                    rawResponse = _state.sent();
                    return [
                        2,
                        fromPairs_default()(Object.keys(rawResponse).map(function(subQueryKey) {
                            var bunnyId = subQueryKey.split("b")[1];
                            return [
                                bunnyId,
                                rawResponse[subQueryKey].length > 0 ? Number(rawResponse[subQueryKey][0].updatedAt) : -Infinity, 
                            ];
                        }))
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch PancakeBunnies latest market updates", error);
                    return [
                        2,
                        {}
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAllPancakeBunniesRecentUpdatedAt(bunnyIds) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Returns the lowest/highest price of any NFT in a collection
 */ var getLeastMostPriceInCollection = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var orderDirection, response, _response, nftSg, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    orderDirection = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "asc";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getNftsMarketData({
                            collection: collectionAddress.toLowerCase(),
                            isTradable: true
                        }, 1, "currentAskPrice", orderDirection)
                    ];
                case 2:
                    response = _state.sent();
                    if (response.length === 0) {
                        return [
                            2,
                            0
                        ];
                    }
                    _response = (0,_sliced_to_array/* default */.Z)(response, 1), nftSg = _response[0];
                    return [
                        2,
                        parseFloat(nftSg.currentAskPrice)
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to lowest price NFTs in collection ".concat(collectionAddress), error);
                    return [
                        2,
                        0
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLeastMostPriceInCollection(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch user trading data for buyTradeHistory, sellTradeHistory and askOrderHistory from the Subgraph
 * @param where a User_filter where condition
 * @returns a UserActivity object
 */ var getUserActivity = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject8(), baseTransactionFields, baseNftFields, baseTransactionFields, baseNftFields, baseNftFields), {
                            address: address
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.user || {
                            askOrderHistory: [],
                            buyTradeHistory: [],
                            sellTradeHistory: []
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch user Activity", error);
                    return [
                        2,
                        {
                            askOrderHistory: [],
                            buyTradeHistory: [],
                            sellTradeHistory: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserActivity(address) {
        return _ref.apply(this, arguments);
    };
}();
var getCollectionActivity = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(address, nftActivityFilter, itemPerQuery) {
        var getAskOrderEvent, isFetchAllCollections, hasCollectionFilter, collectionFilterGql, askOrderTypeFilter, askOrderIncluded, askOrderTypeFilterGql, transactionIncluded, askOrderQueryItem, transactionQueryItem, askOrderGql, transactionGql, res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getAskOrderEvent = function(orderType) {
                        switch(orderType){
                            case types/* MarketEvent.CANCEL */.YG.CANCEL:
                                return types/* AskOrderType.CANCEL */.cP.CANCEL;
                            case types/* MarketEvent.MODIFY */.YG.MODIFY:
                                return types/* AskOrderType.MODIFY */.cP.MODIFY;
                            case types/* MarketEvent.NEW */.YG.NEW:
                                return types/* AskOrderType.NEW */.cP.NEW;
                            default:
                                return types/* AskOrderType.MODIFY */.cP.MODIFY;
                        }
                    };
                    isFetchAllCollections = address === "";
                    hasCollectionFilter = nftActivityFilter.collectionFilters.length > 0;
                    collectionFilterGql = !isFetchAllCollections ? "collection: ".concat(JSON.stringify(address)) : hasCollectionFilter ? "collection_in: ".concat(JSON.stringify(nftActivityFilter.collectionFilters)) : "";
                    askOrderTypeFilter = nftActivityFilter.typeFilters.filter(function(marketEvent) {
                        return marketEvent !== types/* MarketEvent.SELL */.YG.SELL;
                    }).map(function(marketEvent) {
                        return getAskOrderEvent(marketEvent);
                    });
                    askOrderIncluded = nftActivityFilter.typeFilters.length === 0 || askOrderTypeFilter.length > 0;
                    askOrderTypeFilterGql = askOrderTypeFilter.length > 0 ? "orderType_in: ".concat(JSON.stringify(askOrderTypeFilter)) : "";
                    transactionIncluded = nftActivityFilter.typeFilters.length === 0 || nftActivityFilter.typeFilters.some(function(marketEvent) {
                        return marketEvent === types/* MarketEvent.BUY */.YG.BUY || marketEvent === types/* MarketEvent.SELL */.YG.SELL;
                    });
                    askOrderQueryItem = itemPerQuery / 2;
                    transactionQueryItem = itemPerQuery / 2;
                    if (!askOrderIncluded || !transactionIncluded) {
                        askOrderQueryItem = !askOrderIncluded ? 0 : itemPerQuery;
                        transactionQueryItem = !transactionIncluded ? 0 : itemPerQuery;
                    }
                    askOrderGql = askOrderIncluded ? "askOrders(first: ".concat(askOrderQueryItem, ", orderBy: timestamp, orderDirection: desc, where:{\n            ").concat(collectionFilterGql, ", ").concat(askOrderTypeFilterGql, "\n          }) {\n              id\n              block\n              timestamp\n              orderType\n              askPrice\n              seller {\n                id\n              }\n              nft {\n                ").concat(baseNftFields, "\n              }\n          }") : "";
                    transactionGql = transactionIncluded ? "transactions(first: ".concat(transactionQueryItem, ", orderBy: timestamp, orderDirection: desc, where:{\n            ").concat(collectionFilterGql, "\n          }) {\n            ").concat(baseTransactionFields, "\n              nft {\n                ").concat(baseNftFields, "\n              }\n          }") : "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject9(), askOrderGql, transactionGql))
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res || {
                            askOrders: [],
                            transactions: []
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch collection Activity", error);
                    return [
                        2,
                        {
                            askOrders: [],
                            transactions: []
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCollectionActivity(address, nftActivityFilter, itemPerQuery) {
        return _ref.apply(this, arguments);
    };
}();
var getTokenActivity = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(tokenId, collectionAddress) {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject10(), baseTransactionFields, baseNftFields, baseNftFields), {
                            tokenId: tokenId,
                            address: collectionAddress
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.nfts.length > 0) {
                        return [
                            2,
                            {
                                askOrders: res.nfts[0].askHistory,
                                transactions: res.nfts[0].transactionHistory
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            askOrders: [],
                            transactions: []
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch token Activity", error);
                    return [
                        2,
                        {
                            askOrders: [],
                            transactions: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTokenActivity(tokenId, collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get the most recently listed NFTs
 * @param first Number of nfts to retrieve
 * @returns NftTokenSg[]
 */ var getLatestListedNfts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(first) {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,dist.request)(endpoints/* GRAPH_API_NFTMARKET */.Bd, (0,dist.gql)(_templateObject11(), baseNftFields), {
                            first: first
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.nfts
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch NFTs market data", error);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLatestListedNfts(first) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Filter NFTs from a collection
 * @param collectionAddress
 * @returns
 */ var fetchNftsFiltered = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress, filters) {
        var res, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(endpoints/* API_NFT */.C1, "/collections/").concat(collectionAddress, "/filter?").concat((0,querystring.stringify)(filters)))
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
                case 3:
                    console.error("API: Failed to fetch NFT collection ".concat(collectionAddress), res.statusText);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function fetchNftsFiltered(collectionAddress, filters) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * OTHER HELPERS
 */ var getMetadataWithFallback = function(apiMetadata, bunnyId) {
    var _bunnyId;
    // The fallback is just for the testnet where some bunnies don't exist
    return (_bunnyId = apiMetadata[bunnyId]) !== null && _bunnyId !== void 0 ? _bunnyId : {
        name: "",
        description: "",
        collection: {
            name: "Pancake Bunnies"
        },
        image: {
            original: "",
            thumbnail: ""
        }
    };
};
var getPancakeBunniesAttributesField = function(bunnyId) {
    // Generating attributes field that is not returned by API
    // but can be "faked" since objects are keyed with bunny id
    return [
        {
            traitType: "bunnyId",
            value: bunnyId,
            displayType: null
        }, 
    ];
};
var combineApiAndSgResponseToNftToken = function(apiMetadata, marketData, attributes) {
    return {
        tokenId: marketData.tokenId,
        name: apiMetadata.name,
        description: apiMetadata.description,
        collectionName: apiMetadata.collection.name,
        collectionAddress: market_constants/* pancakeBunniesAddress */.J,
        image: apiMetadata.image,
        marketData: marketData,
        attributes: attributes
    };
};
var fetchWalletTokenIdsForCollections = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, collections) {
        var balanceOfCalls, balanceOfCallsResultRaw, balanceOfCallsResult, tokenIdCalls, tokenIdResultRaw, tokenIdResult, nftLocation, walletNfts;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    balanceOfCalls = Object.values(collections).map(function(collection) {
                        var collectionAddress = collection.address;
                        return {
                            address: collectionAddress,
                            name: "balanceOf",
                            params: [
                                account
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: erc721,
                            calls: balanceOfCalls,
                            options: {
                                requireSuccess: false
                            }
                        })
                    ];
                case 1:
                    balanceOfCallsResultRaw = _state.sent();
                    balanceOfCallsResult = balanceOfCallsResultRaw.flat();
                    tokenIdCalls = Object.values(collections).map(function(collection, index) {
                        var ref;
                        var ref1;
                        var balanceOf = (ref1 = (ref = balanceOfCallsResult[index]) === null || ref === void 0 ? void 0 : ref.toNumber()) !== null && ref1 !== void 0 ? ref1 : 0;
                        var collectionAddress = collection.address;
                        return range_default()(balanceOf).map(function(tokenIndex) {
                            return {
                                address: collectionAddress,
                                name: "tokenOfOwnerByIndex",
                                params: [
                                    account,
                                    tokenIndex
                                ]
                            };
                        });
                    }).flat();
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: erc721,
                            calls: tokenIdCalls,
                            options: {
                                requireSuccess: false
                            }
                        })
                    ];
                case 2:
                    tokenIdResultRaw = _state.sent();
                    tokenIdResult = tokenIdResultRaw.flat();
                    nftLocation = types/* NftLocation.WALLET */.Fb.WALLET;
                    walletNfts = tokenIdResult.reduce(function(acc, tokenIdBn, index) {
                        if (tokenIdBn) {
                            var _index = tokenIdCalls[index], collectionAddress = _index.address;
                            acc.push({
                                tokenId: tokenIdBn.toString(),
                                collectionAddress: collectionAddress,
                                nftLocation: nftLocation
                            });
                        }
                        return acc;
                    }, []);
                    return [
                        2,
                        walletNfts
                    ];
            }
        });
    });
    return function fetchWalletTokenIdsForCollections(account, collections) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Helper to combine data from the collections' API and subgraph
 */ var combineCollectionData = function(collectionApiData, collectionSgData) {
    var collectionsMarketObj = fromPairs_default()(collectionSgData.map(function(current) {
        return [
            current.id,
            current
        ];
    }));
    return fromPairs_default()(collectionApiData.filter(function(collection) {
        return collection === null || collection === void 0 ? void 0 : collection.address;
    }).map(function(current) {
        var collectionMarket = collectionsMarketObj[current.address.toLowerCase()];
        var collection = (0,_object_spread/* default */.Z)({}, current, collectionMarket);
        if (current.name) {
            collection.name = current.name;
        }
        return [
            current.address,
            collection
        ];
    }));
};
/**
 * Evaluate whether a market NFT is in a users wallet, their profile picture, or on sale
 * @param tokenId string
 * @param tokenIdsInWallet array of tokenIds in wallet
 * @param tokenIdsForSale array of tokenIds on sale
 * @param profileNftId Optional tokenId of users' profile picture
 * @returns NftLocation enum value
 */ var getNftLocationForMarketNft = function(tokenId, tokenIdsInWallet, tokenIdsForSale, profileNftId) {
    if (tokenId === profileNftId) {
        return types/* NftLocation.PROFILE */.Fb.PROFILE;
    }
    if (tokenIdsForSale.includes(tokenId)) {
        return types/* NftLocation.FORSALE */.Fb.FORSALE;
    }
    if (tokenIdsInWallet.includes(tokenId)) {
        return types/* NftLocation.WALLET */.Fb.WALLET;
    }
    console.error("Cannot determine location for tokenID ".concat(tokenId, ", defaulting to NftLocation.WALLET"));
    return types/* NftLocation.WALLET */.Fb.WALLET;
};
/**
 * Construct complete TokenMarketData entities with a users' wallet NFT ids and market data for their wallet NFTs
 * @param walletNfts TokenIdWithCollectionAddress
 * @param marketDataForWalletNfts TokenMarketData[]
 * @returns TokenMarketData[]
 */ var attachMarketDataToWalletNfts = function(walletNfts, marketDataForWalletNfts) {
    var walletNftsWithMarketData = walletNfts.map(function(walletNft) {
        var marketData = marketDataForWalletNfts.find(function(marketNft) {
            return marketNft.tokenId === walletNft.tokenId && marketNft.collection.id.toLowerCase() === walletNft.collectionAddress.toLowerCase();
        });
        return marketData !== null && marketData !== void 0 ? marketData : {
            tokenId: walletNft.tokenId,
            collection: {
                id: walletNft.collectionAddress.toLowerCase()
            },
            nftLocation: walletNft.nftLocation,
            metadataUrl: null,
            transactionHistory: null,
            currentSeller: null,
            isTradable: null,
            currentAskPrice: null,
            latestTradedPriceInBNB: null,
            tradeVolumeBNB: null,
            totalTrades: null,
            otherId: null
        };
    });
    return walletNftsWithMarketData;
};
/**
 * Attach TokenMarketData and location to NftToken
 * @param nftsWithMetadata NftToken[] with API metadata
 * @param nftsForSale  market data for nfts that are on sale (i.e. not in a user's wallet)
 * @param walletNfts market data for nfts in a user's wallet
 * @param tokenIdsInWallet array of token ids in user's wallet
 * @param tokenIdsForSale array of token ids of nfts that are on sale
 * @param profileNftId profile picture token id
 * @returns NFT[]
 */ var combineNftMarketAndMetadata = function(nftsWithMetadata, nftsForSale, walletNfts, tokenIdsInWallet, tokenIdsForSale, profileNftId) {
    var completeNftData = nftsWithMetadata.map(function(nft) {
        // Get metadata object
        var marketData = nftsForSale.find(function(forSaleNft) {
            return forSaleNft.tokenId === nft.tokenId && forSaleNft.collection && forSaleNft.collection.id === nft.collectionAddress;
        });
        if (!marketData) {
            marketData = walletNfts.find(function(marketNft) {
                return marketNft.collection && marketNft.collection.id === nft.collectionAddress && marketNft.tokenId === nft.tokenId;
            });
        }
        var location = getNftLocationForMarketNft(nft.tokenId, tokenIdsInWallet, tokenIdsForSale, profileNftId);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nft), {
            marketData: marketData,
            location: location
        });
    });
    return completeNftData;
};
var fetchWalletMarketData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(walletNftsByCollection) {
        var walletMarketDataRequests, walletMarketDataResponses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    walletMarketDataRequests = Object.entries(walletNftsByCollection).map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                            var _param, collectionAddress, tokenIdsWithCollectionAddress, tokenIdIn, ref, nftsOnChainMarketData, nftsMarketData;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _param = (0,_sliced_to_array/* default */.Z)(param, 2), collectionAddress = _param[0], tokenIdsWithCollectionAddress = _param[1];
                                        tokenIdIn = tokenIdsWithCollectionAddress.map(function(walletNft) {
                                            return walletNft.tokenId;
                                        });
                                        return [
                                            4,
                                            Promise.all([
                                                getNftsOnChainMarketData(collectionAddress.toLowerCase(), tokenIdIn),
                                                getNftsMarketData({
                                                    tokenId_in: tokenIdIn,
                                                    collection: collectionAddress.toLowerCase()
                                                })
                                            ])
                                        ];
                                    case 1:
                                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                            _state.sent(),
                                            2
                                        ]), nftsOnChainMarketData = ref[0], nftsMarketData = ref[1];
                                        return [
                                            2,
                                            tokenIdIn.map(function(tokenId) {
                                                var nftMarketData = nftsMarketData.find(function(tokenMarketData) {
                                                    return tokenMarketData.tokenId === tokenId;
                                                });
                                                var onChainMarketData = nftsOnChainMarketData.find(function(onChainTokenMarketData) {
                                                    return onChainTokenMarketData.tokenId === tokenId;
                                                });
                                                if (!nftMarketData && !onChainMarketData) return null;
                                                return (0,_object_spread/* default */.Z)({}, nftMarketData, onChainMarketData);
                                            }).filter(Boolean)
                                        ];
                                }
                            });
                        });
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        4,
                        Promise.all(walletMarketDataRequests)
                    ];
                case 1:
                    walletMarketDataResponses = _state.sent();
                    return [
                        2,
                        walletMarketDataResponses.flat()
                    ];
            }
        });
    });
    return function fetchWalletMarketData(walletNftsByCollection) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get in-wallet, on-sale & profile pic NFT metadata, complete with market data for a given account
 * @param account
 * @param collections
 * @param profileNftWithCollectionAddress
 * @returns Promise<NftToken[]>
 */ var getCompleteAccountNftData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, collections, profileNftWithCollectionAddress) {
        var collectionsWithDelist, ref, walletNftIdsWithCollectionAddress, onChainForSaleNfts, walletNftsByCollection, walletMarketData, walletNftsWithMarketData, walletTokenIds, tokenIdsForSale, forSaleNftIds, metadataForAllNfts, completeNftData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    collectionsWithDelist = (0,_object_spread/* default */.Z)({}, collections, delist/* default */.Z);
                    return [
                        4,
                        Promise.all([
                            fetchWalletTokenIdsForCollections(account, collectionsWithDelist),
                            getAccountNftsOnChainMarketData(collectionsWithDelist, account)
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), walletNftIdsWithCollectionAddress = ref[0], onChainForSaleNfts = ref[1];
                    if (profileNftWithCollectionAddress === null || profileNftWithCollectionAddress === void 0 ? void 0 : profileNftWithCollectionAddress.tokenId) {
                        walletNftIdsWithCollectionAddress.unshift(profileNftWithCollectionAddress);
                    }
                    walletNftsByCollection = groupBy_default()(walletNftIdsWithCollectionAddress, function(walletNftId) {
                        return walletNftId.collectionAddress;
                    });
                    return [
                        4,
                        fetchWalletMarketData(walletNftsByCollection)
                    ];
                case 2:
                    walletMarketData = _state.sent();
                    walletNftsWithMarketData = attachMarketDataToWalletNfts(walletNftIdsWithCollectionAddress, walletMarketData);
                    walletTokenIds = walletNftIdsWithCollectionAddress.filter(function(walletNft) {
                        // Profile Pic NFT is no longer wanted in this array, hence the filter
                        return (profileNftWithCollectionAddress === null || profileNftWithCollectionAddress === void 0 ? void 0 : profileNftWithCollectionAddress.tokenId) !== walletNft.tokenId;
                    }).map(function(nft) {
                        return nft.tokenId;
                    });
                    tokenIdsForSale = onChainForSaleNfts.map(function(nft) {
                        return nft.tokenId;
                    });
                    forSaleNftIds = onChainForSaleNfts.map(function(nft) {
                        return {
                            collectionAddress: nft.collection.id,
                            tokenId: nft.tokenId
                        };
                    });
                    return [
                        4,
                        getNftsFromDifferentCollectionsApi((0,_to_consumable_array/* default */.Z)(forSaleNftIds).concat((0,_to_consumable_array/* default */.Z)(walletNftIdsWithCollectionAddress)))
                    ];
                case 3:
                    metadataForAllNfts = _state.sent();
                    completeNftData = combineNftMarketAndMetadata(metadataForAllNfts, onChainForSaleNfts, walletNftsWithMarketData, walletTokenIds, tokenIdsForSale, profileNftWithCollectionAddress === null || profileNftWithCollectionAddress === void 0 ? void 0 : profileNftWithCollectionAddress.tokenId);
                    return [
                        2,
                        completeNftData
                    ];
            }
        });
    });
    return function getCompleteAccountNftData(account, collections, profileNftWithCollectionAddress) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch distribution information for a collection
 * @returns
 */ var getCollectionDistributionApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionAddress) {
        var res, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(endpoints/* API_NFT */.C1, "/collections/").concat(collectionAddress, "/distribution"))
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
                case 3:
                    console.error("API: Failed to fetch NFT collection ".concat(collectionAddress, " distribution"), res.statusText);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function getCollectionDistributionApi(collectionAddress) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 75186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ NftLocation; },
/* harmony export */   "YG": function() { return /* binding */ MarketEvent; },
/* harmony export */   "cP": function() { return /* binding */ AskOrderType; }
/* harmony export */ });
var AskOrderType;
(function(AskOrderType) {
    AskOrderType["NEW"] = "New";
    AskOrderType["MODIFY"] = "Modify";
    AskOrderType["CANCEL"] = "Cancel";
})(AskOrderType || (AskOrderType = {}));
var NftLocation;
(function(NftLocation) {
    NftLocation["FORSALE"] = "For Sale";
    NftLocation["PROFILE"] = "Profile Pic";
    NftLocation["WALLET"] = "In Wallet";
})(NftLocation || (NftLocation = {}));
var MarketEvent;
(function(MarketEvent) {
    MarketEvent["NEW"] = "NEW";
    MarketEvent["CANCEL"] = "CANCEL";
    MarketEvent["MODIFY"] = "MODIFY";
    MarketEvent["BUY"] = "BUY";
    MarketEvent["SELL"] = "SELL";
})(MarketEvent || (MarketEvent = {}));


/***/ }),

/***/ 40580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ pancakeBunniesAddress; },
/* harmony export */   "V": function() { return /* binding */ nftsBaseUrl; }
/* harmony export */ });
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96273);

var nftsBaseUrl = "/nfts";
var pancakeBunniesAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getPancakeBunniesAddress */ .GI)();


/***/ })

}]);